<template>
    <div class="row">
        <div class="col-3 text-center">
            <img :src="logo" class="img-thumbnail" :alt="nomeAssistencia" />
        </div>
        <div class="col-6 align-self-center p-0 font-weight-bold">
            {{ nomeAssistencia }}
        </div>
        <div
            class="col-3 text-center p-0 align-self-center"
            style="font-size: 12px"
        >
            <button 
                type="button" 
                class="btn btn-default"
                @click="abreAjuda"
            >
                <i class="fa fa-question-circle" aria-hidden="true"></i>
                <br />
                Ajuda?
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        logo: String,
        nomeAssistencia: String,
    },
    methods: {
        abreAjuda() {
            document.getElementById('ajuda').scrollIntoView({block: "end", behavior: "smooth"});  

            if (!document.getElementById("contato").classList.contains("show")) {
                document.getElementById('abrirContato').click();
            }
            if (!document.getElementById("cancelar").classList.contains("show")) {
                document.getElementById('abrirCancelar').click();
            }
        }
    }
};
</script>
